<div class="container mt-5">
  <div class="card shadow-sm mx-auto" style="max-width: 400px">
    <div class="card-body text-center p-4">
      <div class="success-icon mb-3">
        <!-- <i
      class="bi bi-check-circle-fill text-success"
      style="font-size: 3rem"
    ></i> -->
        <fa-icon [icon]="faCancel"
                 class="text-danger"
                 style="font-size: 3rem"></fa-icon>
      </div>

      <h3 class="mb-3">{{ "translations.Payment_Process_is_Failed" | translate }} </h3>


      <!--<h2 class="mb-3" [dir]="direction">{{ amount }} {{ currency }}</h2>

  <div class="payment-details">
    <div class="row mb-2">
      <div class="col-6 text-start" [dir]="direction">
        {{ labels.refNumber }}
      </div>
      <div class="col-6 text-end">{{ referenceNumber }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-start" [dir]="direction">
        {{ labels.paymentTime }}
      </div>
      <div class="col-6 text-end">{{ paymentTime }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-start" [dir]="direction">
        {{ labels.paymentMethod }}
      </div>
      <div class="col-6 text-end">{{ paymentMethod }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-start" [dir]="direction">
        {{ labels.senderName }}
      </div>
      <div class="col-6 text-end">{{ senderName }}</div>
    </div>

    <div class="row mb-2">
      <div class="col-6 text-start" [dir]="direction">
        {{ labels.adminFee }}
      </div>
      <div class="col-6 text-end">{{ adminFee }} {{ currency }}</div>
    </div>
  </div>-->

      <div class="text-center mt-4 mb-4">
        <img [src]="logoUrl" alt="Company Logo" style="max-width: 100px" />
      </div>

      <!--<button class="btn btn-dark w-100" (click)="downloadPDF()">
    <i class="bi bi-download me-2"></i>{{ labels.downloadPDF }}
  </button>-->
    </div>
  </div>
</div>
